import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getAdminPurchaseOrders
} from "../../store/action/purchaseOrder";
import AdminPurchaseOrderTable from "../../components/tables/AdminPurchaseOrdersTable";


const AdminPurchaseOrder = () => {
    const { token } = isAuthenticated();
    const [ loading, setloading ] = useState(true);
    const [ purchaseOrders , setPurchaseOrders ] = useState([]);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await getAdminPurchaseOrders(token);
            if (res.success) {
                setPurchaseOrders(res.purchaseOrders)
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };


    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 d-flex justify-content-between">
                <h5>Semua Purhcase Orders</h5>
            </div>
            <AdminPurchaseOrderTable
                data={purchaseOrders}
                loading={loading}
            />
        </div>
    )
};


export default AdminPurchaseOrder;
